import { hasCookie, setCookie } from '../../utils/cookie-utils';
import consentCookiePopupTemplate from './consent-cookie-popup.tpl.html';
import './consent-cookie-popup.less';

const CONSENT_COOKIE = 'qualified-cookie-consent';

export const cookieWarningServiceModule = angular
  .module('Q.services.cookie-warning-service', ['ngAnimate'])

  .directive('consentCookiePopup', function ($animate) {
    return {
      restrict: 'E',
      template: consentCookiePopupTemplate,
      link(scope, elem) {
        scope.consent = () => {
          setCookie(CONSENT_COOKIE, 1, Infinity);
          $animate.leave(elem);
          scope.$destroy();
        };
      },
    };
  })

  .run(function ($compile, $rootScope, $animate, $document) {
    if (!hasCookie(CONSENT_COOKIE)) {
      const el = angular.element(
        '<consent-cookie-popup></consent-cookie-popup>',
      );
      $compile(el)($rootScope.$new(true));
      $animate.enter(el, $document.find('body'));
    }
  });
